import { useRef, useEffect } from "react";

// Inline click-to-edit text. Renders contentEditable when `editable`.
export default function EditableText({ value, onCommit, editable, as = "div", className = "", ...rest }) {
  const ref = useRef(null);
  const Tag = as;

  useEffect(() => {
    if (ref.current && ref.current.innerText !== (value ?? "")) {
      ref.current.innerText = value ?? "";
    }
  }, [value]);

  if (!editable) {
    return <Tag className={className} {...rest}>{value}</Tag>;
  }

  return (
    <Tag
      ref={ref}
      className={`${className} outline-none focus:ring-2 focus:ring-sky-400/70 focus:bg-sky-50/40 rounded-md transition-shadow cursor-text`}
      contentEditable
      suppressContentEditableWarning
      onBlur={(e) => onCommit(e.currentTarget.innerText)}
      {...rest}
    />
  );
}
